import React from "react";
import styles from "./FAQ.module.css";
const FAQ = () => {
  return <div></div>;
};

export default FAQ;
